<template>
  <div>
    <label> {{ title }}</label>
    <div>
      <div v-if="document && !modify" class="d-flex flex-column align-items-center">
        <img :src="document" alt="" class="mb-3 mt-3" :style="'width :' + width + 'px ; height :' + height + 'px'" />
        <div class="d-flex">
          <div class="btn-action-one mr-1" @click="modify = true">
            <i class="bx bx-edit-alt"></i>
            <p class="text-primary">Modifier</p>
          </div>
          <div class="btn-action-one" @click="document = null">
            <i class="bx bx-trash"></i>
            <p class="text-primary">Retirer</p>
          </div>
        </div>
      </div>
    </div>
    <vue-dropzone
      v-if="!document || modify"
      id="dropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      :use-custom-slot="true"
      @vdropzone-file-added="vFileAdded"
    >
      <div class="dropzone-custom-content">
        <i class="display-4 text-muted bx bx-cloud-download"></i>
        <h5>Choisir ou déposer un fichier</h5>
      </div>
    </vue-dropzone>
    <div>
      <p v-if="!document || modify">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'dropzone',

  components: {
    vueDropzone: vue2Dropzone,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    additionalDropzoneOptions: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      modify: false,
      document: this.value,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 100,
        maxFilesize: 4,
        headers: { 'My-Awesome-Header': 'header value' },
        ...this.additionalDropzoneOptions,
      },
    }
  },

  watch: {
    value() {
      this.document = this.value
    },

    document() {
      this.$emit('input', this.document)
    },
  },

  methods: {
    async vFileAdded(file) {
      this.document = null
      await this.vFileAddedPromise(file)
      this.modify = false
    },

    async vFileAddedPromise(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (event) => {
          this.document = event.target.result
          resolve(reader.result)
        }

        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
  },
}
</script>

<style scoped>
label {
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
